import { connect, IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import classNames from 'classnames';
import * as React from 'react';

import { OwnTemplates } from '../adfox/templates/OwnTemplates';
import * as styles from './AdfoxBanner.css';
import { useAdsDisabled } from './hooks/useAdsDisabled';

type SoftOmit<T, K extends keyof T> = {
  [P in keyof T as Exclude<P, K>]: T[P];
};
type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & SoftOmit<T, K>;

type TAdfoxBannerProps = Optional<React.ComponentProps<typeof AdfoxBannerConnected>, 'ownerId'> & {
  className?: string;
  disableYan?: boolean;
  hideable?: boolean;
  slotAfter?: React.ReactNode;
  onClick?(): void;
};

const AdfoxBannerConnected = connect(OwnTemplates);

const AdfoxBannerComponent: React.FC<TAdfoxBannerProps> = ({
  className,
  disableYan,
  hideable = true,
  slotAfter,
  onClick,
  onLoad,
  onStub,
  ...sharedProps
}) => {
  const [isHidden, setIsHidden] = React.useState(false);

  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData) => {
      if (disableYan && data.bundleName === 'banner.direct') {
        setIsHidden(true);
      }

      if (onLoad) {
        onLoad(data);
      }
    },
    [disableYan, onLoad],
  );

  const handleStub = React.useCallback(() => {
    setIsHidden(true);

    if (onStub) {
      onStub();
    }
  }, [onStub]);

  useAdsDisabled(handleStub, [handleStub]);

  if (hideable && isHidden) {
    return null;
  }

  return (
    <aside className={classNames(styles['container'], className)} onClick={handleClick}>
      <AdfoxBannerConnected ownerId={202100} {...sharedProps} onLoad={handleLoad} onStub={handleStub} />
      {slotAfter}
    </aside>
  );
};

export const AdfoxBanner = React.memo(AdfoxBannerComponent);
